import MomentUtils from '@date-io/moment'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from '@material-ui/core/styles'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
// core components
import styles from 'assets/jss/style-component/components/customInputStyle.js'
import classNames from 'classnames'
import { GridItem } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import ReactTooltip from 'react-tooltip'
import { TIPO_INPUT } from 'util/common/const.js'

const theme = createTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        margin: '0px !important'
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: '11px !important'
      }
    },
    MuiInputBase: {
      root: {
        backgroundColor: '#ffffff94',
        fontSize: 'small  !important'
      }
    },
    MuiPopover: {
      paper: {
        backgroundColor: '#fff !important'
      }
    },
    MuiAutocomplete: {
      inputRoot: {
        // padding: "0px !important"},
        popper: {},
        option: {
          fontSize: 'small  !important'
        }
      },
      PrivateNotchedOutline: {
        legendLabelled: {},
        legendNotched: {
          maxWidth: '0px !important'
        }
      }
    }
  }
})

const useStyles = makeStyles(styles)

export default function CustomDate(props) {
  const classes = useStyles()
  const {
    id,
    value,
    onChange,
    //parts,
    labelText,
    error,
    success,
    helperText,
    disabled,
    format,
    sm,
    md,
    hideSelectDateButton,
    minDate,
    maxDate
  } = props

  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error
  })
  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Grid container>
            {labelText !== undefined ? (
              <InputLabel
                className={classes.labelRoot + labelClasses}
                htmlFor={id}
              >
                {labelText}
              </InputLabel>
            ) : null}

            <KeyboardDatePicker
              data-tip={helperText}
              id={id}
              minDate={minDate}
              maxDate={maxDate}
              disableToolbar
              inputVariant={TIPO_INPUT}
              variant="inline"
              autoOk
              error={error}
              fullWidth
              format={format}
              margin="normal"
              label=""
              value={value}
              onChange={onChange}
              disabled={disabled}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                style: hideSelectDateButton ? { display: 'none' } : null
              }}
              InputProps={{}}
            />

            <ReactTooltip />
          </Grid>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </GridItem>
  )
}

CustomDate.propTypes = {
  formControlProps: PropTypes.object,
  id: PropTypes.string,
  style: PropTypes.object,
  labelText: PropTypes.node,
  error: PropTypes.bool,
  success: PropTypes.bool,
  sm: PropTypes.number,
  md: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  helperText: PropTypes.string,
  format: PropTypes.string,
  hideSelectDateButton: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date)
}
